import { Fancybox } from '@fancyapps/ui'
export default {
  mounted () {
    /* fancybox */
    // 1. npm install @fancyapps/ui
    // 2. import { Fancybox } from "@fancyapps/ui";
    // 3. @import "@fancyapps/ui/dist/fancybox.css";
    // 4. 貼上下面這些
    Fancybox.bind('[data-fancybox="gallery"]', {
      Thumbs: false,
      Toolbar: false,
      Image: {
        zoom: false,
        click: false,
        wheel: 'slide'
      }
    })
  }
}
